import { DollarOutlined, UserOutlined } from '@ant-design/icons'

import { useVestingContextV2 } from 'context/vesting-context-provider-v2'

const Header = () => {
  const { totalUser, totalToken, totalClaim } = useVestingContextV2()

  const data = [
    {
      label: 'Total Users',
      value: new Intl.NumberFormat('en-US').format(totalUser || 0),
      icon: <UserOutlined />,
    },
    {
      label: 'Total Token',
      value: new Intl.NumberFormat('en-US').format(totalToken || 0),
      icon: <DollarOutlined />,
    },
    {
      label: 'Total Claim',
      value: new Intl.NumberFormat('en-US').format(totalClaim || 0),
      icon: <UserOutlined />,
    },
  ]

  return (
    <div className="dashboard-container">
      <div className="wrap-dashboard">
        <div className="wrap-box">
          <div className="title">Vesting Overview</div>
          <div className="wrap-columns">
            <div className="columns">
              {data.map((item, index) => {
                return (
                  <div className="colum w-3" key={index}>
                    <div className="guide-box">
                      <div className="box-content">
                        <div className="left-s">
                          <div className="txt">{item.label}</div>
                          <div className="number">{item.value}</div>
                        </div>
                        <div className="right-s">
                          <div className="icon">{item.icon}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Header
